import type { Order } from "./types";
import { poNumber } from "./types";

/** Plain-text order for email or copying: number, delivery date, lines. */
export function orderText(
  order: Pick<Order, "order_number" | "expected_at" | "notes" | "lines">,
  labels: { heading: string; deliver_by: string },
) {
  return [
    `${labels.heading} ${poNumber(order.order_number)}`,
    order.expected_at ? `${labels.deliver_by} ${order.expected_at}` : null,
    "",
    ...order.lines.map(
      (l) =>
        `- ${Number(l.quantity)} × ${l.unit} ${l.description || l.stock_item_name}${l.supplier_code ? ` (${l.supplier_code})` : ""}`,
    ),
    order.notes ? `\n${order.notes}` : null,
  ]
    .filter((x) => x != null)
    .join("\n");
}
